module.exports = __webpack_public_path__ + "static/img/mogo-s1_3@2x.c702d28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/mogo-s1_3@2x.jpg
// module id = 514
// module chunks = 0